
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_45dfSAMeta } from "/workspace/pages/index.vue?macro=true";
import { default as loginvezcvmMPBN3eB4jBUPlMRRPHMVxJle96Nui3_45afcMrEMeta } from "/workspace/pages/login.vue?macro=true";
import { default as pago_45exitosodZy5ChhGR5yXrwlpt5ETUJrZqH0rAABhnH__59_TEHEMeta } from "/workspace/pages/pagos/[transactionId]/pago-exitoso.vue?macro=true";
import { default as procesar_45pagoFzEAw0Ek_45clqEaGh7yetoELkbjZ9DaJdUOcQvAR_dpgMeta } from "/workspace/pages/pagos/[transactionId]/procesar-pago.vue?macro=true";
import { default as pago_45pendienteOftvRJtBzrC2_45MbZl06OLQ43idZ9SKzUBUUDq1C4hsgMeta } from "/workspace/pages/pagos/[transactionId]/pago-pendiente.vue?macro=true";
import { default as pago_45paypalqggxJIsYw8QfkX7JWf0b7upR2KAuTuKT07mhvx2ZWWYMeta } from "/workspace/pages/pagos/[transactionPaymentId]/pago-paypal.vue?macro=true";
import { default as pago_45oxxo_45payhGRXuwHUndk7nUFF70isYwFLesDPyHtrsm5jvg6f5mkMeta } from "/workspace/pages/pagos/[transactionPaymentId]/pago-oxxo-pay.vue?macro=true";
import { default as pago_45apple_45pay07wBQQq2_GSm_maS7qLajRIWvpL6mnCiBCxUGJcw_45jIMeta } from "/workspace/pages/pagos/[transactionPaymentId]/pago-apple-pay.vue?macro=true";
import { default as pago_45google_45payUc8tI6_4526zTbYKk8Ez4VqhEGNFjEnr6oJpxNk2JQLYcMeta } from "/workspace/pages/pagos/[transactionPaymentId]/pago-google-pay.vue?macro=true";
import { default as pagoscv7Bp5QlOfSortJTVx1L2N_45o_FmONxFtsm_glGz8FZMMeta } from "/workspace/pages/pagos.vue?macro=true";
import { default as revisar_45jyYtVOVizd4HBwV4Zorq1gMBtSl9R7rifLQ121xcHsMeta } from "/workspace/pages/compra/[[transactionId]]/revisar.vue?macro=true";
import { default as elegir_45pagoVuSMYB6PQgoGYdMm_UFj2PM4oLR7uHsiXyxyo2r_45tgcMeta } from "/workspace/pages/compra/[[transactionId]]/elegir-pago.vue?macro=true";
import { default as elegir_45envioBwEnCkISqKG1NAxLKhN5Yn02iv_lJPuVDmO_gaTRODAMeta } from "/workspace/pages/compra/[[transactionId]]/elegir-envio.vue?macro=true";
import { default as detalleaJO6cLXioAgBnkWHZjc9TEHpuYH4yG2ErnHe4lOXsWAMeta } from "/workspace/pages/compra/[[transactionId]]/carrito/detalle.vue?macro=true";
import { default as elegir_45mensualidad_45rlZbtPsKn1xh_45AbG4yWO3CbriTGhZOGfpKaDqPXebMMeta } from "/workspace/pages/compra/[[transactionId]]/elegir-mensualidad.vue?macro=true";
import { default as compramXn_45BlQ3J8wAHRBn3FWCNX7PaASoYIlyTs7_Q3p0f3IMeta } from "/workspace/pages/compra.vue?macro=true";
import { default as marcasQYxxHwcberFx0DtE_45ZGEz6FY11M0qRntcwxM0ltjKKUMeta } from "/workspace/pages/marcas.vue?macro=true";
import { default as monederoVrRel65Mr0SHRb8tREDMUT6nwubViyiQQt8BAAgLwVAMeta } from "/workspace/pages/perfil/monedero.vue?macro=true";
import { default as favoritos_45UXkRPEEdaqqDK7U6TVo0XbJlTX5gFCdoV7vpVkQxpAMeta } from "/workspace/pages/perfil/favoritos.vue?macro=true";
import { default as informacionL2RwfMzO1t8BJGQOtDXFC3dxTJREWnSEsLvI3PQUzD0Meta } from "/workspace/pages/perfil/informacion.vue?macro=true";
import { default as dispositivosa3awxbNKzClIe5yHw_45aSbQ3ZJXgHpnEr3oKWDd012uwMeta } from "/workspace/pages/perfil/dispositivos.vue?macro=true";
import { default as indexj5nHI2c81Paut_HoHlilxAxQb2GxQQ4YXFyINFlk_45_YMeta } from "/workspace/pages/perfil/pedidos/index.vue?macro=true";
import { default as _91_91id_93_93JmsGW8_45XB_45aBi7amlps2RwXyIJKIfKEsbPVt5RNzhi8Meta } from "/workspace/pages/perfil/garantias/[[id]].vue?macro=true";
import { default as crearxYatPy8hjArIc2_3_45JildN_OECCltmW6JzvUoJFKsQYMeta } from "/workspace/pages/perfil/direcciones/crear.vue?macro=true";
import { default as indexeECJj4TJoX2M056brY1_u6EPMnja1aANLhJ6E2W8thsMeta } from "/workspace/pages/perfil/direcciones/index.vue?macro=true";
import { default as chatyjZ_yvWkgA_GiNwW0DOVss138eyBKeYwqrMAsGZA_FcMeta } from "/workspace/pages/perfil/pedidos/[id]/chat.vue?macro=true";
import { default as indexFuufpuNLAOVV7fDrCmpErrf6BenrbE_45AzmcJAoW1c0QMeta } from "/workspace/pages/perfil/pedidos/[id]/index.vue?macro=true";
import { default as tarjetaYwgDpLczDPdo8oC0XCbr3o_45cCD5tkjDLYXbtdrpIv2MMeta } from "/workspace/pages/perfil/metodos-pago/tarjeta.vue?macro=true";
import { default as editarJbXLQz1Df5xzKJKFXU1zWAthWHElYCvh8U_6udSEUKwMeta } from "/workspace/pages/perfil/direcciones/[id]/editar.vue?macro=true";
import { default as index74YkZbSV_45diG9XAljaBs_45R_45_vy7Mt2pifpfEnQQMH7QMeta } from "/workspace/pages/perfil/pedidos/[id]/garantia/index.vue?macro=true";
import { default as productosY82LgI_5teINAo995xdMlxwbnxyAzjjnOLvS_XGodikMeta } from "/workspace/pages/perfil/pedidos/[id]/garantia/productos.vue?macro=true";
import { default as perfilT2ycv57nGV9SM59etj6WjUkEVc44KXY8nmPKQiAZ_A0Meta } from "/workspace/pages/perfil.vue?macro=true";
import { default as sucursalesmABbT87_45eQ5jlwQK_cdidVN1Tia8BPbxA14cQLMcVcYMeta } from "/workspace/pages/soporte/sucursales.vue?macro=true";
import { default as contactanosy4G9RsXbwVt37_456LBU_45vSVX1WRh9GPW3s2pPCF1Yr6IMeta } from "/workspace/pages/soporte/contactanos.vue?macro=true";
import { default as facturacionKpfLhBX7kMj32qmnygxfJe_45FjkjOOo2fpM8FYZulLrMMeta } from "/workspace/pages/soporte/facturacion.vue?macro=true";
import { default as formas_45de_45pagoBQh70B47m1_4547cMaycZHgEEZx3RrWcz96pCT_45AEWIjcMeta } from "/workspace/pages/soporte/formas-de-pago.vue?macro=true";
import { default as preguntas_45frecuentesUryrF_45rVNzwnOn9C1mGaUuzRy4ao2KZ1RsUMIRrj_g0Meta } from "/workspace/pages/soporte/preguntas-frecuentes.vue?macro=true";
import { default as soporteIc03jyr7pWufmrdudIzSLWGhggBNR9rFWwRuIwvo5FgMeta } from "/workspace/pages/soporte.vue?macro=true";
import { default as privacidadx_45CeShleK1uMHcJXaWFNIPbTSnBZuEzGGYqqrs_kIIsMeta } from "/workspace/pages/nosotros/privacidad.vue?macro=true";
import { default as aviso_45legalhjtLqSI53kwnCniSvIUEkPj0qjoyeRYV9ywhUKZbk_45MMeta } from "/workspace/pages/nosotros/aviso-legal.vue?macro=true";
import { default as terminos_45y_45condicionesLkkddI8p17Jwt2I6ceM1MnCK_k6ECg_45XVJFdBiH1W7wMeta } from "/workspace/pages/nosotros/terminos-y-condiciones.vue?macro=true";
import { default as politicas_45de_45devoluciondt_45szJ8vsOWwCWi95c9Oi0HudBWOaRnlp7rC5_45_45Tsl0Meta } from "/workspace/pages/nosotros/politicas-de-devolucion.vue?macro=true";
import { default as garantias_45y_45devolucionesfMJ57agCa7RRnunGa4S8HGf8lgYSFTsRTbRDh3fPAJkMeta } from "/workspace/pages/nosotros/garantias-y-devoluciones.vue?macro=true";
import { default as nosotros5eYs4UV3z_45rrexzSDa92TnByLDUek_lMmqKiI_45FcNewMeta } from "/workspace/pages/nosotros.vue?macro=true";
import { default as mi_45cuentaZNV4_452lQXqzDTMbBTkiN2n1EPp3HqrTjekUNfmzhE_45MMeta } from "/workspace/pages/mi-cuenta.vue?macro=true";
import { default as eres_45robotdTvrnwjyLZYB91Uwd3eZzGLC5BAnDtxYLrAAN4A1g_45cMeta } from "/workspace/pages/eres-robot.vue?macro=true";
import { default as registrarmeqNSk4S13EJZmcLL0tPWaHyLNF8ffQnVEI7JL9VXATGUMeta } from "/workspace/pages/registrarme.vue?macro=true";
import { default as _91id_93Keou9ZV4_45wzNZqOty2o0Y5nObLGJRNpHxqbgODRK1gsMeta } from "/workspace/pages/landing/[id].vue?macro=true";
import { default as _91_91id_93_93NtXQN1slfIzdiOpuTxZILKNFfOi_45nrYBharKsHKaEAMMeta } from "/workspace/pages/arma-tu-equipo/[[id]].vue?macro=true";
import { default as _91_91id_93_93ZQ6ujs49mvAvFCBBE_45g_YlFytgpkQelONAVWhlso2pEMeta } from "/workspace/pages/arma-tu-equipo/[assemblyId]/[qty]/[[id]].vue?macro=true";
import { default as arma_45tu_45equipoRRAmzY9rTOWMAoT0iL3E80Am5FsTDyoZZbL3VzAhYewMeta } from "/workspace/pages/arma-tu-equipo.vue?macro=true";
import { default as resetnksEeE0oR69mZozzW1K_45pZnehilmlG8sYszzw4GnRugMeta } from "/workspace/pages/password/reset.vue?macro=true";
import { default as _91slug_937YjS0z4uPD_45NtVaFDzzD5rp4gq0w6_cVPY73bs_45_sXgMeta } from "/workspace/pages/productos/[slug].vue?macro=true";
import { default as verificando_45humanoycyt_45aywqysfJ9QEu2kjnYq8t0O2Esz3BXbi2qGfwWoMeta } from "/workspace/pages/verificando-humano.vue?macro=true";
import { default as _91_46_46_46filters_93TtGohsPUVu0o3sWS38BXNoURDdE1gY5R_45Qiz0J9Eiw8Meta } from "/workspace/pages/buscar/[...filters].vue?macro=true";
import { default as _91id_93oIWoH6rPfAiOj1ewTGOt0rWfrAzD38dmrsrKgatkO0gMeta } from "/workspace/pages/correo/verificar/[id].vue?macro=true";
import { default as busqueda_45por_45categoriasMdjzAIJBkZ2XTzIsfkW5U7kF5DiTTY4JvP9UI2azoYMeta } from "/workspace/pages/busqueda-por-categoria.vue?macro=true";
import { default as index3hxy5_45toM3M5AnsAaRxa8l7NDkNHcb7rk0rfwtxqzhsMeta } from "/workspace/pages/correo/verificar/index.vue?macro=true";
import { default as verificacion_45dos_45pasos4xXmnogH_Vfv_yrEEq8LnIopZSSATO2mhUgBqRcPingMeta } from "/workspace/pages/verificacion-dos-pasos.vue?macro=true";
import { default as reestablecer3adh5m0zpIgfQ1hq3e5PxPZvgZLFnRsxrY3BXj4NaaAMeta } from "/workspace/pages/contrasena/reestablecer.vue?macro=true";
import { default as _91response_93Uxak2VhLEF3RWn3HqOktsNmZtidsTShRV3LRVOhRyfwMeta } from "/workspace/pages/validate-address/[transactionId]/[code]/[missingPayment]/[response].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginvezcvmMPBN3eB4jBUPlMRRPHMVxJle96Nui3_45afcMrEMeta || {},
    component: () => import("/workspace/pages/login.vue")
  },
  {
    name: "pagos",
    path: "/pagos",
    component: () => import("/workspace/pages/pagos.vue"),
    children: [
  {
    name: "success-payment",
    path: ":transactionId()/pago-exitoso",
    meta: pago_45exitosodZy5ChhGR5yXrwlpt5ETUJrZqH0rAABhnH__59_TEHEMeta || {},
    component: () => import("/workspace/pages/pagos/[transactionId]/pago-exitoso.vue")
  },
  {
    name: "pagos-transactionId-procesar-pago",
    path: ":transactionId()/procesar-pago",
    component: () => import("/workspace/pages/pagos/[transactionId]/procesar-pago.vue")
  },
  {
    name: "pending-payment",
    path: ":transactionId()/pago-pendiente",
    meta: pago_45pendienteOftvRJtBzrC2_45MbZl06OLQ43idZ9SKzUBUUDq1C4hsgMeta || {},
    component: () => import("/workspace/pages/pagos/[transactionId]/pago-pendiente.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-paypal",
    path: ":transactionPaymentId()/pago-paypal",
    component: () => import("/workspace/pages/pagos/[transactionPaymentId]/pago-paypal.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-oxxo-pay",
    path: ":transactionPaymentId()/pago-oxxo-pay",
    component: () => import("/workspace/pages/pagos/[transactionPaymentId]/pago-oxxo-pay.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-apple-pay",
    path: ":transactionPaymentId()/pago-apple-pay",
    component: () => import("/workspace/pages/pagos/[transactionPaymentId]/pago-apple-pay.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-google-pay",
    path: ":transactionPaymentId()/pago-google-pay",
    component: () => import("/workspace/pages/pagos/[transactionPaymentId]/pago-google-pay.vue")
  }
]
  },
  {
    name: "compra",
    path: "/compra",
    meta: compramXn_45BlQ3J8wAHRBn3FWCNX7PaASoYIlyTs7_Q3p0f3IMeta || {},
    component: () => import("/workspace/pages/compra.vue"),
    children: [
  {
    name: "cart-review",
    path: ":transactionId?/revisar",
    meta: revisar_45jyYtVOVizd4HBwV4Zorq1gMBtSl9R7rifLQ121xcHsMeta || {},
    component: () => import("/workspace/pages/compra/[[transactionId]]/revisar.vue")
  },
  {
    name: "cart-payment",
    path: ":transactionId?/elegir-pago",
    meta: elegir_45pagoVuSMYB6PQgoGYdMm_UFj2PM4oLR7uHsiXyxyo2r_45tgcMeta || {},
    component: () => import("/workspace/pages/compra/[[transactionId]]/elegir-pago.vue")
  },
  {
    name: "cart-shipping",
    path: ":transactionId?/elegir-envio",
    meta: elegir_45envioBwEnCkISqKG1NAxLKhN5Yn02iv_lJPuVDmO_gaTRODAMeta || {},
    component: () => import("/workspace/pages/compra/[[transactionId]]/elegir-envio.vue")
  },
  {
    name: "cart-detail",
    path: ":transactionId?/carrito/detalle",
    meta: detalleaJO6cLXioAgBnkWHZjc9TEHpuYH4yG2ErnHe4lOXsWAMeta || {},
    component: () => import("/workspace/pages/compra/[[transactionId]]/carrito/detalle.vue")
  },
  {
    name: "cart-monthly",
    path: ":transactionId?/elegir-mensualidad",
    meta: elegir_45mensualidad_45rlZbtPsKn1xh_45AbG4yWO3CbriTGhZOGfpKaDqPXebMMeta || {},
    component: () => import("/workspace/pages/compra/[[transactionId]]/elegir-mensualidad.vue")
  }
]
  },
  {
    name: "marcas",
    path: "/marcas",
    component: () => import("/workspace/pages/marcas.vue")
  },
  {
    name: "perfil",
    path: "/perfil",
    meta: perfilT2ycv57nGV9SM59etj6WjUkEVc44KXY8nmPKQiAZ_A0Meta || {},
    component: () => import("/workspace/pages/perfil.vue"),
    children: [
  {
    name: "perfil-monedero",
    path: "monedero",
    component: () => import("/workspace/pages/perfil/monedero.vue")
  },
  {
    name: "profile.wishlist",
    path: "favoritos",
    meta: favoritos_45UXkRPEEdaqqDK7U6TVo0XbJlTX5gFCdoV7vpVkQxpAMeta || {},
    component: () => import("/workspace/pages/perfil/favoritos.vue")
  },
  {
    name: "account-info",
    path: "informacion",
    meta: informacionL2RwfMzO1t8BJGQOtDXFC3dxTJREWnSEsLvI3PQUzD0Meta || {},
    component: () => import("/workspace/pages/perfil/informacion.vue")
  },
  {
    name: "perfil-dispositivos",
    path: "dispositivos",
    component: () => import("/workspace/pages/perfil/dispositivos.vue")
  },
  {
    name: "orders",
    path: "pedidos",
    meta: indexj5nHI2c81Paut_HoHlilxAxQb2GxQQ4YXFyINFlk_45_YMeta || {},
    component: () => import("/workspace/pages/perfil/pedidos/index.vue")
  },
  {
    name: "perfil-garantias-id",
    path: "garantias/:id?",
    component: () => import("/workspace/pages/perfil/garantias/[[id]].vue")
  },
  {
    name: "profile.addresses.create",
    path: "direcciones/crear",
    meta: crearxYatPy8hjArIc2_3_45JildN_OECCltmW6JzvUoJFKsQYMeta || {},
    component: () => import("/workspace/pages/perfil/direcciones/crear.vue")
  },
  {
    name: "profile.addresses",
    path: "direcciones",
    meta: indexeECJj4TJoX2M056brY1_u6EPMnja1aANLhJ6E2W8thsMeta || {},
    component: () => import("/workspace/pages/perfil/direcciones/index.vue")
  },
  {
    name: "order-chat",
    path: "pedidos/:id()/chat",
    meta: chatyjZ_yvWkgA_GiNwW0DOVss138eyBKeYwqrMAsGZA_FcMeta || {},
    component: () => import("/workspace/pages/perfil/pedidos/[id]/chat.vue")
  },
  {
    name: "order-show",
    path: "pedidos/:id()",
    meta: indexFuufpuNLAOVV7fDrCmpErrf6BenrbE_45AzmcJAoW1c0QMeta || {},
    component: () => import("/workspace/pages/perfil/pedidos/[id]/index.vue")
  },
  {
    name: "perfil-metodos-pago-tarjeta",
    path: "metodos-pago/tarjeta",
    component: () => import("/workspace/pages/perfil/metodos-pago/tarjeta.vue")
  },
  {
    name: "profile.addresses.edit",
    path: "direcciones/:id()/editar",
    meta: editarJbXLQz1Df5xzKJKFXU1zWAthWHElYCvh8U_6udSEUKwMeta || {},
    component: () => import("/workspace/pages/perfil/direcciones/[id]/editar.vue")
  },
  {
    name: "perfil-pedidos-id-garantia",
    path: "pedidos/:id()/garantia",
    component: () => import("/workspace/pages/perfil/pedidos/[id]/garantia/index.vue")
  },
  {
    name: "perfil-pedidos-id-garantia-productos",
    path: "pedidos/:id()/garantia/productos",
    component: () => import("/workspace/pages/perfil/pedidos/[id]/garantia/productos.vue")
  }
]
  },
  {
    name: "soporte",
    path: "/soporte",
    component: () => import("/workspace/pages/soporte.vue"),
    children: [
  {
    name: "soporte-sucursales",
    path: "sucursales",
    meta: sucursalesmABbT87_45eQ5jlwQK_cdidVN1Tia8BPbxA14cQLMcVcYMeta || {},
    alias: ["/sucursales"],
    component: () => import("/workspace/pages/soporte/sucursales.vue")
  },
  {
    name: "soporte-contactanos",
    path: "contactanos",
    meta: contactanosy4G9RsXbwVt37_456LBU_45vSVX1WRh9GPW3s2pPCF1Yr6IMeta || {},
    alias: ["/contactanos"],
    component: () => import("/workspace/pages/soporte/contactanos.vue")
  },
  {
    name: "soporte-facturacion",
    path: "facturacion",
    meta: facturacionKpfLhBX7kMj32qmnygxfJe_45FjkjOOo2fpM8FYZulLrMMeta || {},
    alias: ["/facturacion"],
    component: () => import("/workspace/pages/soporte/facturacion.vue")
  },
  {
    name: "support.payment_ways",
    path: "formas-de-pago",
    meta: formas_45de_45pagoBQh70B47m1_4547cMaycZHgEEZx3RrWcz96pCT_45AEWIjcMeta || {},
    alias: ["/formas-de-pago"],
    component: () => import("/workspace/pages/soporte/formas-de-pago.vue")
  },
  {
    name: "soporte-preguntas-frecuentes",
    path: "preguntas-frecuentes",
    meta: preguntas_45frecuentesUryrF_45rVNzwnOn9C1mGaUuzRy4ao2KZ1RsUMIRrj_g0Meta || {},
    alias: ["/preguntas-frecuentes"],
    component: () => import("/workspace/pages/soporte/preguntas-frecuentes.vue")
  }
]
  },
  {
    name: "nosotros",
    path: "/nosotros",
    component: () => import("/workspace/pages/nosotros.vue"),
    children: [
  {
    name: "nosotros-privacidad",
    path: "privacidad",
    meta: privacidadx_45CeShleK1uMHcJXaWFNIPbTSnBZuEzGGYqqrs_kIIsMeta || {},
    alias: ["/privacidad"],
    component: () => import("/workspace/pages/nosotros/privacidad.vue")
  },
  {
    name: "nosotros-aviso-legal",
    path: "aviso-legal",
    meta: aviso_45legalhjtLqSI53kwnCniSvIUEkPj0qjoyeRYV9ywhUKZbk_45MMeta || {},
    alias: ["/aviso-legal"],
    component: () => import("/workspace/pages/nosotros/aviso-legal.vue")
  },
  {
    name: "nosotros-terminos-y-condiciones",
    path: "terminos-y-condiciones",
    meta: terminos_45y_45condicionesLkkddI8p17Jwt2I6ceM1MnCK_k6ECg_45XVJFdBiH1W7wMeta || {},
    alias: ["/terminos-y-condiciones"],
    component: () => import("/workspace/pages/nosotros/terminos-y-condiciones.vue")
  },
  {
    name: "nosotros-politicas-de-devolucion",
    path: "politicas-de-devolucion",
    meta: politicas_45de_45devoluciondt_45szJ8vsOWwCWi95c9Oi0HudBWOaRnlp7rC5_45_45Tsl0Meta || {},
    alias: ["/politicas-de-devolucion"],
    component: () => import("/workspace/pages/nosotros/politicas-de-devolucion.vue")
  },
  {
    name: "nosotros-garantias-y-devoluciones",
    path: "garantias-y-devoluciones",
    meta: garantias_45y_45devolucionesfMJ57agCa7RRnunGa4S8HGf8lgYSFTsRTbRDh3fPAJkMeta || {},
    alias: ["/garantias-y-devoluciones"],
    component: () => import("/workspace/pages/nosotros/garantias-y-devoluciones.vue")
  }
]
  },
  {
    name: "mi-cuenta",
    path: "/mi-cuenta",
    component: () => import("/workspace/pages/mi-cuenta.vue")
  },
  {
    name: "failed-human-verify",
    path: "/eres-robot",
    meta: eres_45robotdTvrnwjyLZYB91Uwd3eZzGLC5BAnDtxYLrAAN4A1g_45cMeta || {},
    component: () => import("/workspace/pages/eres-robot.vue")
  },
  {
    name: "registrarme",
    path: "/registrarme",
    component: () => import("/workspace/pages/registrarme.vue")
  },
  {
    name: "landing-id",
    path: "/landing/:id()",
    component: () => import("/workspace/pages/landing/[id].vue")
  },
  {
    name: "assembly-new",
    path: "/arma-tu-equipo",
    meta: arma_45tu_45equipoRRAmzY9rTOWMAoT0iL3E80Am5FsTDyoZZbL3VzAhYewMeta || {},
    component: () => import("/workspace/pages/arma-tu-equipo.vue"),
    children: [
  {
    name: "assembly-edit",
    path: ":id?",
    meta: _91_91id_93_93NtXQN1slfIzdiOpuTxZILKNFfOi_45nrYBharKsHKaEAMMeta || {},
    component: () => import("/workspace/pages/arma-tu-equipo/[[id]].vue")
  },
  {
    name: "assembly-edit-with-cart",
    path: ":assemblyId()/:qty()/:id?",
    meta: _91_91id_93_93ZQ6ujs49mvAvFCBBE_45g_YlFytgpkQelONAVWhlso2pEMeta || {},
    component: () => import("/workspace/pages/arma-tu-equipo/[assemblyId]/[qty]/[[id]].vue")
  }
]
  },
  {
    name: "password-reset",
    path: "/password/reset",
    component: () => import("/workspace/pages/password/reset.vue")
  },
  {
    name: "products",
    path: "/productos/:slug()",
    meta: _91slug_937YjS0z4uPD_45NtVaFDzzD5rp4gq0w6_cVPY73bs_45_sXgMeta || {},
    component: () => import("/workspace/pages/productos/[slug].vue")
  },
  {
    name: "human-verify",
    path: "/verificando-humano",
    meta: verificando_45humanoycyt_45aywqysfJ9QEu2kjnYq8t0O2Esz3BXbi2qGfwWoMeta || {},
    component: () => import("/workspace/pages/verificando-humano.vue")
  },
  {
    name: "search",
    path: "/buscar/:filters(.*)*",
    meta: _91_46_46_46filters_93TtGohsPUVu0o3sWS38BXNoURDdE1gY5R_45Qiz0J9Eiw8Meta || {},
    component: () => import("/workspace/pages/buscar/[...filters].vue")
  },
  {
    name: "correo-verificar-id",
    path: "/correo/verificar/:id()",
    component: () => import("/workspace/pages/correo/verificar/[id].vue")
  },
  {
    name: "search_categories",
    path: "/busqueda-por-categoria",
    meta: busqueda_45por_45categoriasMdjzAIJBkZ2XTzIsfkW5U7kF5DiTTY4JvP9UI2azoYMeta || {},
    component: () => import("/workspace/pages/busqueda-por-categoria.vue")
  },
  {
    name: "correo-verificar",
    path: "/correo/verificar",
    component: () => import("/workspace/pages/correo/verificar/index.vue")
  },
  {
    name: "verificacion-dos-pasos",
    path: "/verificacion-dos-pasos",
    meta: verificacion_45dos_45pasos4xXmnogH_Vfv_yrEEq8LnIopZSSATO2mhUgBqRcPingMeta || {},
    alias: ["/verificacion-dos-pasos"],
    component: () => import("/workspace/pages/verificacion-dos-pasos.vue")
  },
  {
    name: "contrasena-reestablecer",
    path: "/contrasena/reestablecer",
    component: () => import("/workspace/pages/contrasena/reestablecer.vue")
  },
  {
    name: "validate-address-transactionId-code-missingPayment-response",
    path: "/validate-address/:transactionId()/:code()/:missingPayment()/:response()",
    component: () => import("/workspace/pages/validate-address/[transactionId]/[code]/[missingPayment]/[response].vue")
  }
]